import React, { useState } from 'react';
import './project.css';

import MyBlogifyPic from '../Assects/blogify.png';
import myChatGPTpic from '../Assects/chatGPT.png';
import myHealthCarePic from '../Assects/healthCare.png';
import myStorePic from '../Assects/firstStore.png';
import secondStore from '../Assects/secondStore.png';
import FoodDelivery from '../Assects/foodDelivery.png';
import shilajit from '../Assects/shilajit.png';
import proposals from '../Assects/proposals.png'
import penprose from '../Assects/penprose.png'


const ProjectCard = ({ project }) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="project-card">
      <img className="project-image" src={project.img} alt={project.title} />
      <h4 className="project-title">{project.title}</h4>

      <button
        className="toggle-btn"
        onClick={() => setShowDetails(prev => !prev)}
      >
        {showDetails ? 'Show Less' : 'Learn More'}
      </button>

      {showDetails && (
        <div className="project-details">
          <p className="project-desc">{project.description}</p>
          <div className="project-tags">
            {project.technologies.map((tech, index) => (
              <span key={index} className="tech-tag">{tech}</span>
            ))}
          </div>
          <a className="project-link" href={project.link} target="_blank" rel="noopener noreferrer">
            View Project
          </a>
        </div>
      )}
    </div>
  );
};

const Projects = () => {
  const frontendProjects = [
    {
      title: "My Own ChatGPT",
      img: myChatGPTpic,
      link: "https://saddamanwar185.github.io/myChatGPT/",
      description: "Frontend replica of ChatGPT using React.",
      technologies: ["React", "CSS", "Redux", "AI"]
    },
    {
      title: "HealthCare Website",
      img: myHealthCarePic,
      link: "https://saddamanwar185.github.io/healthCare/",
      description: "Modern healthcare website layout.",
      technologies: ["HTML", "CSS", "JavaScript","React ApexCharts"]
    },
    {
      title: "E-Commerce Store",
      img: myStorePic,
      link: "https://saddamanwar185.github.io/mystore/",
      description: "Animated online store UI demo.",
      technologies: ["React", "Redux",]
    },
    {
      title: "Shilajit Landing Page",
      img: shilajit,
      link: "https://saddamanwar185.github.io/shilajitEnergy/",
      description: "Product branding promo page.",
      technologies: ["HTML", "CSS","JavaScript", "GSAP"]
    },
    {
      title: "Second E-Commerce Store",
      img: secondStore,
      link: "https://saddamanwar185.github.io/newStore/",
      description: "Animated online store with animations notifications and fake order functionality",
      technologies: ["React", "Redux",]
    }
  ];

  const backendProjects = [
    {
      title: "Full Stack Blog",
      img: MyBlogifyPic,
      link: "https://blogify-both-fb-git-main-saddam-anwars-projects.vercel.app/",
      description: "Blogging platform with full-stack functionality.",
      technologies: ["MongoDB", "Express", "React", "Redux" , "Node", "Tailwind css","JWT","Cloudnary"]
    },
    {
      title: "Food Delivery App",
      img: FoodDelivery,
      link: "https://food-delivery-mern-1.vercel.app/",
      description: "Full-stack food delivery with auth/cart.",
      technologies: ["MongoDB", "Express", "React", "Redux", "Node", "Tailwind css","JWT","Cloudnary"]
    },
    {
      title: "Todo List Type App",
      img: proposals,
      link: "https://saddamanwar185.github.io/myProposals/",
      description: "You can login and save your informations like job titles or a TODO",
      technologies: ["MongoDB", "Express", "React", "Redux", "Node", "Tailwind css","JWT"]
    },
    {
      title: "PenProse Services",
      img: penprose,
      link: "https://penprose.github.io/portfolio",
      description: "A full stack portfolio website for PenProse Services",
      technologies: ["MongoDB", "Express", "React", "Redux", "Node", "Tailwind css","JWT", "Cloudnary"]
    },
  ];

  return (
    <section className="projectSection">
      <div className="projects">
        <div className="project-section">
          <h3 className="section-title">Frontend Projects</h3>
          <div className="project-grid">
            {frontendProjects.map((project, index) => (
              <ProjectCard project={project} key={index} />
            ))}
          </div>
        </div>
        <div className="project-section">
          <h3 className="section-title" style={
            {marginTop: '40px'}
          }>Backend (MERN) Projects</h3>
          <div className="project-grid">
            {backendProjects.map((project, index) => (
              <ProjectCard project={project} key={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
